import ConsumerChangePassword from "features/auth/components/consumerChangePasswordForm";

function ChangePasswordPage() {
  return <ConsumerChangePassword />;
}

export default ChangePasswordPage;
